import { StoreListingApi } from '../../generated/api';
import configuration from './configuration';

const storeListingService = new StoreListingApi(configuration);

export default storeListingService;
